(function () {
    'use strict';

    angular
        .module('jotApp')
        .controller('ScriptsReleasesDialogController', ScriptsReleasesDialogController);

    ScriptsReleasesDialogController.$inject = ['$state','$timeout', '$scope', 'entity', 'ScriptsReleases', 'ScriptsTypes','ParseLinks','AlertService', 'DataUtils', '$window'];

    function ScriptsReleasesDialogController($state,$timeout, $scope, entity, ScriptsReleases, ScriptsTypes, ParseLinks, AlertService, DataUtils, $window) {
        var vm = this;
        vm.scriptsReleases = entity;
        vm.scriptsTypes = [];
        vm.page = 0;

        $timeout(function () {
            angular.element('.form-group:eq(1)>input').focus();
        });

        var onSaveSuccess = function (result) {
            $scope.$emit('jotApp:scriptsReleasesUpdate', result);
            vm.isSaving = false;
            $state.go('scripts-releases');
        };

        var onSaveError = function () {
            vm.isSaving = false;
        };

        vm.save = function () {
            vm.isSaving = true;
            if(!vm.fileContentRaw || vm.fileContentRaw == 0) {
                AlertService.error('Empty File');
                return;
            }
            if (vm.scriptsReleases.id !== null) {
                ScriptsReleases.update(vm.scriptsReleases, onSaveSuccess, onSaveError);
            } else {
                ScriptsReleases.save(vm.scriptsReleases, onSaveSuccess, onSaveError);
            }
        };

        vm.clear = function () {
            $state.go('scripts-releases');
        };

        vm.loadAll = function () {

            ScriptsTypes.query({
                filter: 'tabdevicereleases-is-null',
                page: vm.page,
                size: 200
            }, onSuccess, onError);

            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                for (var i = 0; i < data.length; i++) {
                    vm.scriptsTypes.push(data[i]);
                }
                if(vm.scriptsReleases && vm.scriptsReleases.fileContent.length > 0) {
                    vm.fileContentRaw = $window.atob(vm.scriptsReleases.fileContent);
                }
            }

            function onError(error) {
                AlertService.error(error.data.message);
            }
        };

        vm.loadPage = function (page) {
            if (page <= vm.links['last']) {
                vm.page = page;
                vm.loadAll();
            }
        };

        vm.setFileFromEditor = function () {
            vm.scriptsReleases.fileContent = $window.btoa(vm.fileContentRaw);
        };

        vm.byteSize = DataUtils.byteSize;

        vm.loadAll();
    }
})();
